import helper from "../../../urls/helper";
import surveying from "../../../urls/roles/surveying";

import {
    makeDeleteRequest,
    makeGetRequest,
    sendPatchRequest,
    makeParticalUpdateRequest,
    makePostRequest, sendDeleteRequest,
    sendGetRequest, sendPostRequest, finalizeRequest, makePostRequestFile
} from "../../../helper/requests";
import creator from "../../../urls/roles/creator";
import router from "../../../router";
import names from "../../../modules/creator/routers/names";
import surveys from "@/urls/roles/admin";

const state = {
    stages: [],
    fields: [],
}

const getters = {

}

const mutations = {
    set_stages: (state, data) => {
      /**
       * Устанавливает список этапов опроса
       */
        state.stages = data
    },
}

const actions = {
    loadSurveyList: ({commit}, {url, finalizer, catcher}) => {
      /**
       * Загружает список опросов создателя
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса (опционально)
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url) url = creator.CREATOR.SURVEY.LIST()
        sendGetRequest(url, (data) => finalizer(data, url), catcher)
    },
    createSurvey: ({commit}, {data, finalizer, catcher}) => {
      /**
       * Создает новый опрос
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для создания опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.SURVEY.LIST()
        sendPostRequest(
            url, data, finalizer, catcher,
        )

    },
    duplicateSurvey: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Дублирует существующий опрос
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор опроса для дублирования
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.SURVEY.DUPLICATE(id)
        sendPostRequest(url, null, finalizer, catcher)
    },
    updateSurvey: ({commit}, {data, id, finalizer, catcher}) => {
      /**
       * Обновляет существующий опрос
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Обновленные данные опроса
       * @param {number} id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.SURVEY.EDIT(id)
        sendPatchRequest(
            url, data, finalizer, catcher
        )
    },
    loadSurveyDetail: ({commit, getters}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию об опросе
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {number} id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.SURVEY.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    deleteSurveyDetail: ({commit}, {item, finalizer, catcher}) => {
      /**
       * Удаляет опрос
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} item - Объект опроса для удаления
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.SURVEY.DELETE(item.id)
        sendDeleteRequest(url, finalizer, catcher)
    },
    loadStatisticFile: ({commit}, {id,get, finalizer, catcher}) => {
      /**
       * Загружает статистический файл
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор опроса
       * @param {Object} get - Параметры фильтрации статистики
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.FILE.UNLODING(id, get)
        sendGetRequest(
            url,
            finalizer,
            catcher
        )
    },
    surveyGetKindParam: ({commit}, {survey_id, search, finalizer, catcher}) => {
      /**
       * Получает параметры типа опроса с поиском
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {string} search - Строка поиска
       * @param {Function} finalizer - Функция-обработчик
       * @param {Function} catcher - Функция-обработчик ошибок
       * @returns {void}
       */
        let get = {}
        if (search) get['search'] = search
        let url = creator.CREATOR.KIND_PARAM.GET_KIND_PARAM(survey_id, get)
        sendGetRequest(
            url,
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    surveyListKindParam: ({commit}, {survey_id, finalizer, catcher}) => {
      /**
       * Загружает список всех параметров типа опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.KIND_PARAM.LIST(survey_id)
        sendGetRequest(
            url,
            finalizer,
            catcher
        )
    },
    surveyCreateKindParam: ({commit}, {survey_id, data, finalizer, catcher}) => {
      /**
       * Создает новый параметр типа опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Object} data - Данные для создания параметра
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.KIND_PARAM.CREATE(survey_id)
        sendPostRequest(
            url,
            data,
            finalizer,
            catcher
        )
    },
    surveyDeleteKindParam: ({commit}, {survey_id, id, finalizer, catcher}) => {
      /**
       * Удаляет параметр типа опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} id - Идентификатор параметра
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.KIND_PARAM.DELETE(survey_id, id)
        sendDeleteRequest(
            url,
            finalizer,
            catcher
        )
    },
    surveyDeleteAllKindParam: ({commit}, {survey_id, finalizer, catcher}) => {
      /**
       * Удаляет все параметры типа опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.KIND_PARAM.DELETEALL(survey_id)
        sendDeleteRequest(
            url,
            finalizer,
            catcher
        )
    },
    // Invite
    personalLinkList: ({commit}, {survey_id, finalizer, cather}) => {
      /**
       * Загружает список персональных ссылок
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.INVITE.LIST(survey_id)
        sendGetRequest(
            url,
            finalizer,
            cather
        )
    },
    personalLinkCreate: ({commit}, {survey_id, data, finalizer, cather}) => {
      /**
       * Создает новую персональную ссылку
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Object} data - Данные для создания ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.INVITE.CREATE(survey_id)
        sendPostRequest(
            url,
            data,
            finalizer,
            cather
        )
    },
    personalLinkDetail: ({commit}, {survey_id, id, finalizer, cather}) => {
      /**
       * Загружает детальную информацию о персональной ссылке
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} id - Идентификатор ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.INVITE.DETAIL(survey_id, id)
        sendGetRequest(
            url,
            finalizer,
            cather
        )
    },
    personalLinkDelete: ({commit}, {survey_id, id, finalizer, cather}) => {
      /**
       * Удаляет персональную ссылку
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} id - Идентификатор ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.INVITE.DELETE(survey_id, id)
        sendDeleteRequest(
            url,
            finalizer,
            cather
        )
    },
    surveySendInvite: ({commit}, {data, survey_id, finalizer, cather}) => {
      /**
       * Отправляет приглашения по email
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для отправки приглашений
       * @param {string|number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.INVITE.SEND(survey_id)
        sendPostRequest(
            url,
            data,
            finalizer,
            cather
        )
    },

    // Stages
    loadStageList: ({commit}, {survey_id, finalizer, catcher}) => {
      /**
       * Загружает список этапов опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE.LIST(survey_id, {'size': 100})
        sendGetRequest(url,
            (data) => {
                commit('set_stages', data)
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    editStage: ({commit}, {data, survey_id, finalizer, catcher}) => {
      /**
       * Редактирует этап
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для обновления этапа
       * @param {string|number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE.EDIT(survey_id, data.id)
        sendPatchRequest(url, data,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    saveStage: ({commit}, {data, survey_id, finalizer, catcher}) => {
      /**
       * Создает новый этап
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для создания этапа
       * @param {string|number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE.SAVE(survey_id)
        sendPostRequest(url, data,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    copyStage: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
      /**
       * Копирует существующий этап
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {string|number} stage_id - Идентификатор этапа для копирования
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE.COPY(survey_id, stage_id,)
        sendGetRequest(url,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    deleteStage: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
      /**
       * Удаляет этап
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE.DELETE(survey_id, stage_id)
        sendDeleteRequest(url,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },

    // Stage fields
    listStageField: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
      /**
       * Загружает список полей этапа
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE_FIELDS.LIST(survey_id, stage_id, {'size': 100})
            sendGetRequest(url,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    addStageField: ({commit}, {survey_id, stage_id, data, finalizer, catcher}) => {
      /**
       * Добавляет поле к этапу
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {Object} data - Данные для создания поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE_FIELDS.CREATE(survey_id, stage_id)
        if(data.file !== undefined && data.file !== null && data.file.get_params === undefined) {
            let file = data.file
            let formData = new FormData()
            for (let el in data){
                if (data[el] !== null && el !== 'file' )
                    formData.append(`${el}`, data[el])
            }
            if (typeof file === 'object' && file !== null)
                if (String(file.name).length < 130 )
                    formData.append('file', file)

            finalizeRequest(
                makePostRequestFile(
                    url,
                    formData,
                    'POST'
                ),
                finalizer,
                catcher
            )
        } else {
            let send = {...data}
            if(data.file !== undefined && data.file !== null){
                delete send.file;
            }
            sendPostRequest(
                url, send,
                (data) => {
                    if (finalizer) finalizer(data)
                },
                (error_data) => {
                    if (catcher) catcher(error_data)
                }
            )
        }

    },
    editStageField: ({state, commit}, {data, survey_id, stage_id, finalizer, catcher}) => {
      /**
       * Редактирует поле этапа
       * @param {Object} state - Состояние модуля
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для обновления поля
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE_FIELDS.EDIT(survey_id, stage_id, data.id)

        if(data.file !== undefined && data.file !== null && data.file.get_params === undefined) {
            let file = data.file
            let formData = new FormData()
            for (let el in data){
                if (data[el] !== null && el !== 'file' )
                    formData.append(`${el}`, data[el])
            }
            if (typeof file === 'object' && file !== null)
                if (String(file.name).length < 130 )
                    formData.append('file', file)

            finalizeRequest(
                makePostRequestFile(
                    url,
                    formData,
                    'PATCH'
                ),
                finalizer,
                catcher
            )
        } else {
            let send = {...data}
            if(data.file !== undefined && data.file !== null){
                delete send.file;
            }
            sendPatchRequest(
                url, send,
                    (data) => {
                        if (finalizer) finalizer(data)
                    },
                    (error_data) => {
                        if (catcher) catcher(error_data)
                    }
            )
        }
    },
    deleteStageField: ({dispatch, commit}, {survey_id, stage_id, id, finalizer, catcher}) => {
      /**
       * Удаляет поле из этапа
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {number} id - Идентификатор поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.STAGE_FIELDS.DELETE(survey_id, stage_id, id)
        sendDeleteRequest(url,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },

    // Fields
    loadFieldDetail: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию о поле
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор поля
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.FIELDS.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },

    // Attempts
    loadAttemptList: ({commit}, {url, finalizer, catcher}) => {
      /**
       * Загружает список попыток прохождения
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url)
            url = creator.CREATOR.ATTEMPTS.LIST();
        sendGetRequest(url, (data) => finalizer(data, url), catcher)
    },
    loadAttemptDetail: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию о попытке
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.ATTEMPTS.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadAttemptStageList: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает список этапов попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.ATTEMPTS.STAGES(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadAttemptStageFieldList: ({commit}, {id, stage_id, finalizer, catcher}) => {
      /**
       * Загружает поля этапа попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.ATTEMPTS.FIELDS(id, stage_id)
        sendGetRequest(url, finalizer, catcher)
    },
    deleteAttemptDetail: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Удаляет попытку прохождения
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.ATTEMPTS.DETAIL(id)
        sendDeleteRequest(url, finalizer, catcher)
    },

    // Choices
    loadChoiceList: ({commit}, {url, finalizer, catcher}) => {
      /**
       * Загружает список вариантов выбора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url) url = creator.CREATOR.CHOICES.LIST()
        sendGetRequest(url, (data) => finalizer(data, url), catcher)
    },
    loadChoiceDetail: ({commit, getters}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию о варианте выбора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {number} id - Идентификатор варианта выбора
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICES.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    createChoice: ({dispatch, commit}, {data, finalizer, catcher}) => {
      /**
       * Создает новый вариант выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для создания варианта выбора
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICES.SAVE()
        sendPostRequest(url, data, finalizer, catcher)
    },
    updateChoice: ({dispatch, commit}, {id, data, finalizer, catcher}) => {
      /**
       * Обновляет существующий вариант выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор варианта выбора
       * @param {Object} data - Обновленные данные
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICES.EDIT(id)
        sendPatchRequest(url, data, finalizer, catcher);
    },
    deleteChoice: ({dispatch, commit}, {id, finalizer, catcher}) => {
      /**
       * Удаляет вариант выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор варианта выбора
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICES.DELETE(id)
        sendDeleteRequest(url, finalizer, catcher)
    },

    // Choice values
    loadChoiceValueList: ({commit}, {value_choices_id, finalizer, catcher}) => {
      /**
       * Загружает список значений для варианта выбора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.LIST(value_choices_id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadChoiceListAll: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает все значения всех вариантов выбора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор опроса или группы
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.LIST_ALL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadChoiceValueDetail: ({commit, getters}, {value_choices_id, id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию о значении варианта выбора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {number} params.id - Идентификатор значения
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.DETAIL(value_choices_id, id)
        sendGetRequest(url, finalizer, catcher)
    },
    createChoiceValueOne: ({dispatch, commit}, {value_choices_id, data, finalizer, catcher}) => {
      /**
       * Создает одно значение для варианта выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {Object} data - Данные для создания значения
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.ONE_CREATE(value_choices_id)
        sendPostRequest(url, data, finalizer, catcher)
    },
    changeListOfChoiceValue: ({dispatch, commit}, {value_choices_id, data, finalizer, catcher}) => {
      /**
       * Массово создает или изменяет список значений
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {Array} data - Массив данных для массового создания
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.MANY_CREATE(value_choices_id)
        sendPostRequest(url, data, finalizer, catcher)
    },
    updateChoiceValue: ({dispatch, commit}, {value_choices_id, data, finalizer}) => {
      /**
       * Обновляет значение варианта выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {Object} data - Обновленные данные
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       */
        let url = creator.CREATOR.CHOICE_VALUE.EDIT(value_choices_id, data.id)
        makeParticalUpdateRequest(url, data)
            .then(resp => {
                return resp.json()
            })
            .then(json => {
                finalizer(json)
            })
    },
    deleteChoiceValue: ({dispatch, commit}, {value_choices_id, id, finalizer, catcher}) => {
      /**
       * Удаляет значение варианта выбора
       * @param {Function} dispatch - Функция для вызова других actions
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} value_choices_id - Идентификатор родительского варианта выбора
       * @param {number} id - Идентификатор значения
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = creator.CREATOR.CHOICE_VALUE.DELETE(value_choices_id, id)
        sendDeleteRequest(url, finalizer, catcher)
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
